import swal from "sweetalert";
import axiosInstance from "../api";
import { GET_REFERAL_USER_BY_ID } from "../constants";
import { setGetReferralData } from "../reusable/reusableSlice";

export const addReferalUser = async (data, setIsLoading) => {
    try {
        const response = await axiosInstance.post("/refferrer/create", data);
        if (response.data.status) {
            swal({
                text: response?.data?.response?.message,
                icon: "success",
                button: "Close",
                timer: 1500,
            });
            return response;
        } else {
            swal({
                text: response?.data?.message,
                icon: "error",
                button: "Close",
                timer: 1500,
            });
        }
        return response
    } catch (err) {
        console.error(err);
    } finally {
        setIsLoading(false)
    }
};

export const getAllReferalUsers = async (data, setIsLoading) => {
    try {
        const response = await axiosInstance.post("/refferrer/get_all", data);
        if (response.data.status) {
            return response;
        } else {
            swal({
                text: response?.data?.message,
                icon: "error",
                button: "Close",
                timer: 1500,
            });
        }
    } catch (err) {
        console.error(err);
    } finally {
        setIsLoading(false)
    }
};

export const deleteReferalUser = async (id) => {
    try {
        const response = await axiosInstance.delete(`refferrer/delete/${id}`);
        if (response.data.status) {
            swal({
                text: response?.data?.response.message,
                icon: "success",
                button: "Close",
                timer: 1500,
            });
            return response;
        } else {
            swal({
                text: response?.data?.message,
                icon: "error",
                button: "Close",
                timer: 1500,
            });
        }
    } catch (err) {
        console.error(err);
    }
};

export const getUserById = (id) => async (dispatch) => {
    try {
        const response = await axiosInstance.get(`/refferrer/get_byid/${id}`);
        if (response?.data?.status) {
            dispatch({ type: GET_REFERAL_USER_BY_ID, Refaraluserbyid: response.data.response });
            return response;
        }
        swal({
            text: response?.data?.response?.message,
            icon: "error",
            button: "Close",
            timer: 1500,
        });
    } catch (err) {
        console.error(err);
    } 
};

export const updateReferalUser = (data, setLoading) => async (dispatch) => {
    try {
        const response = await axiosInstance.post("/refferrer/update", data);
        if (response.data.status) {
            swal({
                text: response?.data?.response?.message,
                icon: "success",
                button: "Close",
                timer: 1500,
            });
            dispatch(getUserById(data.id))
            return response;
        } else {
            swal({
                text: response?.data?.message,
                icon: "error",
                button: "Close",
                timer: 1500,
            });
        }
    } catch (err) {
        console.error(err);
    } finally {
        setLoading(false);
    }
};

export const generateNewReferralCodeRefer = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post("refferrer/generate_referral", data);
      if (response?.data?.status) {
        swal({
          text: response?.data?.response?.message,
          icon: "success",
          button: "Close",
          timer: 1500,
        });
        // window.location.reload()
        dispatch(getUserById(data.userID))
        return response;
      }
      else{
        swal({
          text: response?.data?.message,
          icon: "error",
          button: "Close",
          timer: 1500,
        });
      }
  
    } catch (err) {
      console.error(err);
    } 
  };

  export const getReferralListDataReferal = (data) => async (dispatch) => {
    try {
      const response = await axiosInstance.post(`/refferrer/user_referral_list`,data);
      if (response?.data) {
        dispatch(setGetReferralData(response?.data?.response))
      } else {
        dispatch(setGetReferralData([]))
      }
    } catch (err) {
      dispatch(setGetReferralData([]))
    }
  };

